import { action, makeObservable, observable, reaction } from 'mobx';
import { UiStore } from './ui';
import { appConfig } from '../settings';
import { IActivityLogItem, IFilterParams, ISelectList } from '../interfaces';
import { getActivityLogList } from '../middleware';
import { apiParamsCleaner } from '../instruments';

export class ActivityLogStore {
    private constructor() {
        makeObservable(this);
        reaction(
            () => this.forcedUpdateTime,
            () => {
                const UiStoreInstance = UiStore.getInstance();
                const params = UiStoreInstance.params;
                const cleanParams = apiParamsCleaner(params, this.filterParams);
                getActivityLogList(cleanParams).then();
            },
            {
                delay: appConfig.APIDelay,
            },
        );
    }

    private static instance: ActivityLogStore;
    public static getInstance(): ActivityLogStore {
        if (!ActivityLogStore.instance) {
            ActivityLogStore.instance = new ActivityLogStore();
        }
        return ActivityLogStore.instance;
    }

    @observable list: IActivityLogItem[] = [];
    @action setActivityLogList(activityLogList: IActivityLogItem[]): void {
        this.list = activityLogList;
    }

    @observable forcedUpdateTime = 0;
    @action setForcedUpdateTime(): void {
        this.forcedUpdateTime = Date.now();
    }

    @observable entitySelect: ISelectList = appConfig.entity;
    @action setEntitySelect(list: ISelectList): void {
        this.entitySelect = list;
    }

    @observable filterParams: IFilterParams = {
        dateRange: true,
        defaultDateRangeType: 'month',
        isDateRangeCleanedDefaultURL: true,
        isDateRangeMaxDayToDay: true,
        pageNumber: true,
        pageSize: true,
        search: true,
        userId: true,
        entityId: true,
    };

    @action cleanStore(): void {
        this.list = [];
    }
}
